import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_staff/device-catalog/active/$id/_layout/contract-and-cost/_contract-and-cost/deal/_deal/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/device-catalog/active/$id/contract-and-cost/deal/contract',
      params: { id: params.id },
    });
  },
});
